import React from 'react'
import PropTypes from 'prop-types'
import { isTimeFormatValid } from '../../../../helpers/time'
import { isTimeValid } from "../../../../helpers/poolTime"

export class TimeEditor extends React.Component {

  constructor(props) {
    super(props)

    this.state = { isValid: false }
  }

  componentDidMount() {
    this.setState({ isValid: isTimeFormatValid(this.props.value) && isTimeValid(this.props.row.poolTimes, this.props.value, this.props.index, this.props.row.closed) })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.value !== this.props.value) {
      this.setState({ isValid: isTimeFormatValid(this.props.value) && isTimeValid(this.props.row.poolTimes, this.props.value, this.props.index, this.props.row.closed) })
    }
  }

  render() {
    return <div>
      <input name="timeValueInput"
        className={'form-control form-control-sm timeInput ' + (!this.state.isValid && 'invalidInput')}
        value={this.props.value} onChange={(event) => this.props.onChange(event.target.value)}/>
      {this.state.isValid ? '' : <span className="invalidInputText">Invalid Time</span>}
    </div>

  }
}

export default TimeEditor

TimeEditor.propTypes = {
  value: PropTypes.string.isRequired,
  row: PropTypes.exact({
    poolTimes: PropTypes.arrayOf(PropTypes.exact({
      startTime: PropTypes.string.isRequired,
      endTime: PropTypes.string.isRequired
    }).isRequired),
    closed: PropTypes.bool.isRequired
  }),
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/containers/pools/details/deliveryHours/timeEditor.js